class recentlyProducts extends HTMLElement {
  constructor() {
    super();
    this.recentlyViewed = [];
    this.container = document.querySelector('.recently-viewed-main');

    let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
    if (getRecentlyViewed != null) {
      this.recentlyViewed = JSON.parse(getRecentlyViewed);        
      this.recentlyViewed.reverse();

      if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed);
    }  
  }

  showRecentlyViewed(products) {
    let recentlyViewedHTML = '';
    let totalProducts = 0;
    products.forEach(product => {
      const currentIndex = product.id == window.globalVariables.product.id;
      if(currentIndex == false){
        totalProducts += 1;
        recentlyViewedHTML += `<div class="grid-view col-6 col-md-3 mb-3"><div class="product-card p-sm-3 p-2 position-relative bg-white rounded border h-100 grid-view">
        <div class="card-image">      
          <div class="card-image-inner position-relative">
            <a href="/products/${product.handle}" class="d-block">
              <img src="${product.image}"
                loading="lazy"
                class="border-image object-fit-contain w-100 bg-white"
                alt="${product.title}" width="{{ product_image.width }}" height="auto" > 
            </a>
          </div>
        </div>
        
        <modal-opener data-modal="#QuickAdd-${product.id}" class="quick-view-modal-opener grid-view position-absolute start-50 top-50 translate-middle">
          <button href="/products/${product.handle}" data-product-url="/products/${product.handle}?view=quickview" class="quick-view btn-primary btn">
            <span>Add To Cart</span>
            <div class="loading__spinner hidden">
              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>
        </modal-opener>
      
        <div class="card-data mt-4">
          <div class="product-content-wrap text-start">
            <a href="/products/${product.handle}" class="fw-semibold h5 font-size-md link--text text-decoration-none" title="${product.title}">
              ${product.title.substring(0,50)}${product.title.length > 50 ? '...' : ''}
            </a>        
            <div class="mt-md-2 grid__item">
              <span class="fw-semibold font-size-md h4">${formatMoney((product.price), window.globalVariables.money_format)}</span>
              <s class="fw-semibold font-size-md ms-2 ${(product.compared_at_price != null && product.compared_at_price > product.price) ? "" : "d-none"} text-gray-500">${formatMoney((product.compared_at_price), window.globalVariables.money_format)}</s>
              <div id="sk-collection-product-review" data-product-id="${product.id}"></div>
            </div>
          </div>
          
          <quick-add-modal id="QuickAdd-${product.id}" class="quick-add-modal d-none">
            <div
              role="dialog"
              aria-modal="true"
              class="quick-add-modal__content custom-scroll"
              tabindex="-1"
            >
              <button
                id="ModalClose-${product.id}"
                type="button"
                class="quick-add-modal__toggle p-2"
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
              </svg>
              </button>
              <div id="QuickAddInfo-${product.id}" class="quick-add-modal__content-info bg-body border rounded border-image custom-scroll"></div>
            </div>
          </quick-add-modal>
        </div>
      </div></div>`;
      }
    });

    if(totalProducts > 0){
      let sliderHTML = `${recentlyViewedHTML}`;
      this.container.classList.remove('d-none');
      this.container.querySelector("recently-products").innerHTML = sliderHTML;  
    }      
  }
}
customElements.define("recently-products", recentlyProducts);

var recentlyViewed = [];
manageRecentlyViewed = () => {
  let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
  if (getRecentlyViewed != null) {
    recentlyViewed = JSON.parse(getRecentlyViewed);        
    recentlyViewed.reverse();
  }
  
  if(window.globalVariables.template == 'product'){
    const productData = window.globalVariables.product;
    let requiredData = {
      id: productData.id,
      handle: productData.handle,
      title: productData.title,
      price: productData.price,
      compared_at_price: productData.compare_at_price,
      image: productData.featured_image
    }
    addToRecentlyViewed(requiredData);
  }
}

addToRecentlyViewed = (product) => {
  const productExist = recentlyViewed.findIndex((x) => {
    return x.id == product.id;
  });

  if (productExist == -1) {
    recentlyViewed.push(product)
    localStorage.setItem(
      "user_recently_viewed",
      JSON.stringify(recentlyViewed)
    );
  }
}
manageRecentlyViewed();
